import React, { useState } from 'react';
import clsx from 'clsx';
import { EventCardProps } from './types';

const EventCard: React.FC<EventCardProps> = ({ eventId, imageUrl, title, className }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div
      className={clsx(
        'flex flex-col items-center gap-3',
        'w-[200px] min-w-[200px] sm:w-[240px] sm:min-w-[240px]',
        className
      )}
      data-event-id={eventId}
    >
      {/* Circular Image with Gradient Border */}
      <div className="relative group">
        {/* Gradient Border Container */}
        <div className="rounded-full bg-gradient-1 p-[6px]">
          {/* Image Container */}
          <div className="relative overflow-hidden rounded-full h-[180px] w-[180px]">
            {!imageError ? (
              <img
                src={imageUrl}
                alt={title}
                className={clsx(
                  'h-full w-full object-cover transition-transform duration-300 ease-in-out',
                  'group-hover:scale-110',
                  imageLoaded ? 'opacity-100' : 'opacity-0'
                )}
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageError(true)}
                loading="lazy"
              />
            ) : (
              <div className="h-full w-full bg-bg-primaryMedium flex items-center justify-center">
                <span className="text-text-primaryLight text-sm">No image</span>
              </div>
            )}
            {/* Loading placeholder */}
            {!imageLoaded && !imageError && (
              <div className="absolute inset-0 bg-bg-primaryMedium animate-pulse" />
            )}
          </div>
        </div>
      </div>

      {/* Title */}
      <h3 className="text-center text-xl font-bold text-text-primary sm:text-2xl">
        {title}
      </h3>
    </div>
  );
};

export { EventCard };
